import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { TwoFactorStatus } from '@/enums/two-factor-status.enum'

import { setTwoFactorVerified } from '@/state/auth/slices/index.slices'
import ActionTypes from '../constants'
import {
  DisableTwoFactorPayload,
  DisableTwoFactorResponse,
  UserState,
} from '../models'

const apiService: RestApiService = Container.get(RestApiService)

export const disableCodesThunk = createAsyncThunk(
  ActionTypes.DISABLE_CODES,
  async (payload: DisableTwoFactorPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'POST',
        endpoint: 'twoFactorAuthentication/disable',
        body: payload,
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: DisableTwoFactorResponse = await apiService.sendAuthData(
        auth.token || '',
      )

      if (response.status === 200) {
        thunkAPI.dispatch(setTwoFactorVerified(false))
      }

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const disableCodesExtraReducer = (
  builder: ActionReducerMapBuilder<UserState>,
) => {
  builder.addCase(disableCodesThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(disableCodesThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.twoFactorVerified =
      payload.status !== 500 ? TwoFactorStatus.ACTIVE : TwoFactorStatus.ERROR
  })
}

export default disableCodesExtraReducer
